import { Badge, Button } from "reactstrap";
import { Activity, PlayCircle, Shield, Zap } from "react-feather";
import { auditStatusBadge } from "../TryoutAIAudit.utils";

// Header halaman + info tryout (title, status audit, tryout id).
const TryoutAIAuditHeader = ({
  title,
  verifiedByAI,
  id,
  isStarting,
  status,
  isLoading,
  onStartClick,
  onReauditClick,
}) => {
  const statusBadge = auditStatusBadge(verifiedByAI);
  const buttonLabel = isStarting
    ? "Memulai..."
    : status === "auditing"
      ? "Audit Sedang Berjalan"
      : status === "done" || status === "error"
        ? "Mulai Audit Ulang"
        : "Mulai Audit AI";
  const statusText =
    verifiedByAI === "done"
      ? "Audit selesai dan siap ditindaklanjuti"
      : verifiedByAI === "failed"
        ? "Audit gagal dan memerlukan perhatian"
        : verifiedByAI === "process"
          ? "Proses audit sedang berjalan dan sudah masuk antrean"
          : "Audit belum dijalankan";

  return (
    <div
      className="rounded-4 border border-light-subtle p-3 p-lg-4 mb-4"
      style={{
        background: "linear-gradient(135deg, #f8fbff 0%, #ffffff 100%)",
        boxShadow: "0 12px 32px rgba(15, 23, 42, 0.04)",
      }}
    >
      <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3">
        <div className="d-flex gap-3 align-items-start">
          <div
            className="rounded-3 p-2"
            style={{ background: "linear-gradient(135deg, #dbeafe 0%, #eef5ff 100%)" }}
          >
            <Zap size={20} color="#2563eb" strokeWidth={1.8} />
          </div>
          <div>
            <h4 className="mb-1 fw-bold">Audit AI Tryout</h4>
            <p className="mb-0 text-muted">
              Pantau temuan, tinjau hasil secara cepat, dan tindak lanjuti dengan alur yang lebih jelas.
            </p>
          </div>
        </div>
        <Button
          color="primary"
          className="rounded-pill px-3 py-2 d-inline-flex align-items-center gap-2 shadow-sm"
          onClick={onStartClick}
          disabled={isStarting || status === "auditing"}
        >
          <PlayCircle size={16} />
          {buttonLabel}
        </Button>
      </div>

      {!isLoading && (title || verifiedByAI) && (
        <div
          className="mt-3 rounded-4 border bg-white p-3 p-lg-4"
          style={{ borderColor: "#e4ebf7", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.8)" }}
        >
          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3">
            <div className="flex-grow-1">
              {title && (
                <div className="fw-semibold mb-2" style={{ wordBreak: "break-word" }}>
                  {title}
                </div>
              )}
              <div className="d-flex flex-wrap align-items-center gap-2">
                <Badge
                  color={statusBadge.color}
                  pill
                  className="text-uppercase fw-semibold border py-2 px-3 d-inline-flex align-items-center gap-2"
                  style={{
                    backgroundColor:
                      statusBadge.color === "success"
                        ? "#e8f8ef"
                        : statusBadge.color === "warning"
                          ? "#fff8e8"
                          : statusBadge.color === "danger"
                            ? "#ffe8e8"
                            : "#eaf3ff",
                  }}
                >
                  <span className="d-inline-flex align-items-center">{statusBadge.label}</span>
                </Badge>
                <small className="text-muted">{statusText}</small>
              </div>
            </div>
            <div className="d-flex flex-wrap gap-2">
              {id && <span className="small text-muted">Tryout ID: {id}</span>}
              {/* <span className="small text-muted d-inline-flex align-items-center gap-1">
                <Activity size={13} />
                Update real-time
              </span> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TryoutAIAuditHeader;
